import React, { useState,useEffect } from "react";
import TableCell from "./TableCell";
import TableRowOverlay from "./TableRowOverlay";

var PreventMultipleTooltipsManager = /** @class */ (function () {
  function PreventMultipleTooltipsManager() {
      this.currentHideFunc = null;
  }
  PreventMultipleTooltipsManager.prototype.changeTooltip = function (hideFunc) {
      var _a;
      (_a = this.currentHideFunc) === null || _a === void 0 ? void 0 : _a.call(this);
      this.currentHideFunc = hideFunc;
  };
  PreventMultipleTooltipsManager.prototype.unmount = function (hideFunc) {
      if (hideFunc === this.currentHideFunc) {
          this.currentHideFunc = null;
      }
  };
  return PreventMultipleTooltipsManager;
}());
var preventMultipleTooltipsManager = new PreventMultipleTooltipsManager();

const TableRow = (props) => {
  const [overlay, setOverlay] = useState(false);
  const openOverlayClick = (e) => {
    if (!overlay){
      preventMultipleTooltipsManager.changeTooltip(() => setOverlay(false));
    }
     setOverlay(!overlay);
  };
  useEffect(() => (
    () => {
      if (overlay){
        preventMultipleTooltipsManager.unmount(openOverlayClick);
      }
    }
  ), [openOverlayClick]);
  return (
    <div key={props.idx} className="finderTable-row">
      {props.row
        .slice(0, props.config.numberColsVisible || 1000)
        .map((cell, index) => {
          return (
            <div
              key={index}
              data-header={props.header[index]?.v}
              className={`${"row" + props.idx} ${"col" + index} ${
                cell?.H ? "highlight" : ""
              }  ${!cell?.v ? "no-content" : ""} finderTable-row-cell`}>
              <TableCell cell={cell} />
            </div>
          );
        })}
      {props.config.numberColsVisible && (
        <div
          className={`${"row" + props.idx} ${
            "col" + props.config.numberColsVisible
          } finderTable-extra-cells-overlay-trigger`}
          onClick={openOverlayClick}>
            <span className="finderTable-extra-cells-icon">&#8942;</span>
          
          {overlay && (
            <TableRowOverlay
              config={props.config}
              header={props.header}
              row={props.row}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default TableRow;
